import { combineReducers } from 'redux';
import { showPageReducer } from "./system/showPage"
const rootReducer = combineReducers({
    showPageData: showPageReducer,
});

export default rootReducer;
